import { styled } from '@mui/system'
import { Box } from '@mui/material'

export const FiltersContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const SelectContainer = styled(Box)(({ theme }) => {
  return `
		display: flex;
		flex-direction: row;
		gap: ${theme.spacing(1)};
	`
})
